import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

class LoadingIndicator extends Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    const props = { ...this.props };
    const { classes } = this.props;
    delete props.show;

    return (
      <div className={classes.loadingIndicatorStyle}>
        <CircularProgress
          style={this.props.style}
          size={this.props.size || 30}
        />
      </div>
    );
  }
}

LoadingIndicator.propTypes = {
  show: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  size: PropTypes.number,
};

LoadingIndicator.defaultProps = {
  show: true,
  style: null,
  size: null,
};

const styles = () => ({
  loadingIndicatorStyle: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 30,
  },
});

export default withStyles(styles)(LoadingIndicator);


// WEBPACK FOOTER //
// ./src/app/components/loading-indicator/loading-indicator.js